import { useState } from 'react';

import { UploadFixedImagePreview } from '@/shared/components/ui';
import ImageUploadComponente from '@/shared/components/ui/UploadImage/ImageUploadComponente';


export const useUploadImageComponent = () => {
  ///* fotos OT entrada -----------
  const [fotoNap, setFotoNap] = useState<File | null>(null);
  const [fotoEtiquetaConector, setFotoEtiquetaConector] = useState<File | null>(
    null
  );
  const [fotoEtiquetaChaqueta, setFotoEtiquetaChaqueta] = useState<File | null>(
    null
  );
  const [fotoInteriorNap, setFotoInteriorNap] = useState<File | null>(null);
  // const [fotoPotenciaEnNap, setFotoPotenciaEnNap] = useState<File | null>(null);
  const [fotoPotenciaPuerto, setFotoPotenciaPuerto] = useState<File | null>(null);
  const [fotoReversoONT, setFotoReversoONT] =
    useState<File | null>(null);
  
  const [fotoTipoInstalacion, setFotoTipoInstalacion] = useState<File | null>(null);
  const [fotoAdicional, setFotoAdicional] = useState<File | null>(null);
  const [fotoPuntosRedInstalados, setFotoPuntosRedInstalados] = useState<File[] | null>(null);
  const [fotoPuntosRedNoInstalados, setFotoPuntosRedNoInstalados] = useState<File[] | null>(null);
  const [fotoRouterAdicionalInstalados, setFotoRouterAdicionalInstalados] = useState<File[] | null>(null);

  ///* fotos OT salida -----------
  const [fotoOrdenTrabajo, setFotoOrdenTrabajo] = useState<File | null>(null);
  const [fotoPotenciaONT, setFotoPotenciaONT] = useState<File | null>(null);
  const [fotoTest5g, setFotoTest5g] = useState<File | null>(null);
  const [fotoPonSerialONT, setFotoPonSerialONT] = useState<File | null>(null);
  const [fotoUbicacionONT, setFotoUbicacionONT] = useState<File | null>(null);
  const [fotoCroquisVirtual, setFotoCroquisVirtual] = useState<File | null>(
    null
  );
  const [fotoReserva, setFotoReserva] = useState<File | null>(null);
  const [fotoTest2_4g, setFotoTest2_4g] = useState<File | null>(null);

  const [fotoMaterialesContrato, setFotoMaterialesContrato] =
    useState<File | null>(null);
  const [fotoPuntoInicial, setFotoPuntoInicial] = useState<File | null>(null);
  const [fotoPuntoFinal, setFotoPuntoFinal] = useState<File | null>(null);

  const [fotoUbicacionEquipoAC, setFotoUbicacionEquipoAC] =
    useState<File | null>(null);
  const [fotoSerialMacAC, setFotoSerialMacAC] = useState<File | null>(null);
  const [fotoClienteContrato, setFotoClienteContrato] = useState<File | null>(
    null
  );
  const [fotoAnexoDebitoTarjeta, setFotoAnexoDebitoTarjeta] =
    useState<File | null>(null);

  // fotos rechazo
  const [fotoRechazoTecnico1, setFotoRechazoTecnico1] = useState<File | null>(
    null
  );
  const [fotoRechazoTecnico2, setFotoRechazoTecnico2] = useState<File | null>(
    null
  );

  ///* foto de producto
  const [fotoProducto1, setFotoProducto1] = useState<File | null>(null)

  ///* Pendiente actualizar contrato -> vendedor

  /* const [imgCedulaFrontal, setImgCedulaFrontal] = useState<File | null>(null);
  const [imgCedulaReverso, setImgCedulaReverso] = useState<File | null>(null);
  const [imgAceptacion, setImgAceptacion] = useState<File | null>(null);
  const [imgRespaldo, setImgRespaldo] = useState<File | null>(null);
  const [imgTarjeta, setImgTarjeta] = useState<File | null>(null);
  const [imgRUC, setImgRUC] = useState<File | null>(null);
  const [imgRUCNombramiento, setImgRUCNombramiento] = useState<File | null>(null); */
  

  ///* Imagenes de SOLICITUD BENEFICIO PROSPECTO
  const [fotoTutorDiscapacidad, setFotoTutorDiscapacidad] = useState<File | null>(
    null
  );
  const [fotoDocumentoLegalRepresentante, setFotoDocumentoLegalRepresentante] = useState<File | null>(
    null
  );
  const [fotoBonoDesarrolloHumano, setFotoBonoDesarrolloHumano] = useState<File | null>(
    null
  );
  ///* Imagenes de cliente preventa corporativa
  const [fotoCedCorporativoFrontal, setFotoCedCorporativoFrontal] = useState<File | null>(
    null
  );
  const [fotoCedCorporativoPosterior, setFotoCedCorporativoPosterior] = useState<File | null>(
    null
  );
  const [fotoCorporativoRUC, setFotoCorporativoRUC] = useState<File | null>(
    null
  );

  ///* upload component
  // const UploadImageComponent = useMemo(
  //   () => ImageUploadComponente,
  //   [

  //     fotoTipoInstalacion,
  //     fotoAdicional,
  //     fotoPuntosRedInstalados,
  //     fotoPuntosRedNoInstalados,
  //     fotoRouterAdicionalInstalados,

  //     fotoOrdenTrabajo,
  //     fotoNap,
  //     fotoTest5g,
  //     fotoReserva,
  //     fotoTest2_4g,
  //     fotoPonSerialONT,
  //     fotoUbicacionONT,
  //     fotoCroquisVirtual,
  //     fotoPotenciaONT,
  //     fotoMaterialesContrato,
  //     fotoUbicacionEquipoAC,
  //     fotoSerialMacAC,
  //     fotoClienteContrato,
  //     fotoAnexoDebitoTarjeta,
  //     fotoRechazoTecnico1,
  //     fotoRechazoTecnico2,

  //     ///* Imagenes de SOLICITUD BENEFICIO PROSPECTO
  //     fotoTutorDiscapacidad,
  //     fotoDocumentoLegalRepresentante,
  //     fotoBonoDesarrolloHumano,
  //   ]
  // );
  // const UploadImageToUpdAndPreview = useMemo(() => UploadFixedImagePreview, []);
  const UploadImageComponent = ImageUploadComponente;
  const UploadImageToUpdAndPreview = UploadFixedImagePreview;

  return {
    UploadImageComponent,
    UploadImageToUpdAndPreview,

    fotoOrdenTrabajo,
    setFotoOrdenTrabajo,
    fotoTest5g,
    setFotoTest5g,
    fotoReserva,
    setFotoReserva,
    fotoTest2_4g,
    setFotoTest2_4g,
    fotoPonSerialONT,
    setFotoPonSerialONT,
    fotoUbicacionONT,
    setFotoUbicacionONT,
    fotoCroquisVirtual,
    setFotoCroquisVirtual,
    fotoPotenciaONT,
    setFotoPotenciaONT,
    fotoMaterialesContrato,
    setFotoMaterialesContrato,
    fotoPuntoInicial,
    setFotoPuntoInicial,
    fotoPuntoFinal,
    setFotoPuntoFinal,
    fotoUbicacionEquipoAC,
    setFotoUbicacionEquipoAC,
    fotoSerialMacAC,
    setFotoSerialMacAC,
    fotoClienteContrato,
    setFotoClienteContrato,
    fotoAnexoDebitoTarjeta,
    setFotoAnexoDebitoTarjeta,

    // pre rechazo by tecnico
    fotoRechazoTecnico1,
    setFotoRechazoTecnico1,
    fotoRechazoTecnico2,
    setFotoRechazoTecnico2,

    // fotos OT entrada

    fotoNap,
    setFotoNap,
    fotoEtiquetaConector,
    setFotoEtiquetaConector,
    fotoEtiquetaChaqueta,
    setFotoEtiquetaChaqueta,
    fotoInteriorNap,
    setFotoInteriorNap,
    fotoPotenciaPuerto,
    setFotoPotenciaPuerto,
    fotoReversoONT,
    setFotoReversoONT,
    //fotos OT adicionales de entrada
    fotoTipoInstalacion, setFotoTipoInstalacion,
    fotoAdicional, setFotoAdicional,
    fotoPuntosRedInstalados, setFotoPuntosRedInstalados,
    fotoPuntosRedNoInstalados, setFotoPuntosRedNoInstalados,
    fotoRouterAdicionalInstalados, setFotoRouterAdicionalInstalados,

    fotoProducto1,
    setFotoProducto1,

    ///* Imagenes de SOLICITUD BENEFICIO PROSPECTO
    fotoTutorDiscapacidad, 
    setFotoTutorDiscapacidad,
    fotoDocumentoLegalRepresentante, 
    setFotoDocumentoLegalRepresentante,
    fotoBonoDesarrolloHumano, 
    setFotoBonoDesarrolloHumano,

    ///* Imagenes de PREVENTA CORPORATIVA
    fotoCedCorporativoFrontal, setFotoCedCorporativoFrontal,
    fotoCedCorporativoPosterior, setFotoCedCorporativoPosterior,
    fotoCorporativoRUC, setFotoCorporativoRUC
  };
};
